<template>
  <div class="index-container">
    <div class="banner">
      <div class="banner-list-box">
        <div class="banner-list flex-between">
          <a
            href="javascript:;"
            class="banner-list-item"
            :class="{ active: item.id === tabIng.id }"
            v-for="(item, index) in tabList"
            :key="index"
            @click="onSelectTab(item)"
          >
            <span>{{ item.name }}</span>
            <i class="active-icon" v-show="item.id === tabIng.id"></i>
          </a>
        </div>
      </div>
    </div>
    <index-zhi-shi-dian
      v-if="tabIng.id === 1"
      @stagetSubjectCallBack="onStagetSubjectCallBack"
      :stageSubject="userStageSubject"
    ></index-zhi-shi-dian>
    <index-tong-bu
      v-if="tabIng.id === 2"
      @stagetSubjectCallBack="onStagetSubjectCallBack"
      :stageSubject="userStageSubject"
    ></index-tong-bu>
    <index-zhuan-ti
      v-if="tabIng.id === 4"
      @stagetSubjectCallBack="onStagetSubjectCallBack"
      :stageSubject="userStageSubject"
    ></index-zhuan-ti>
    <index-fu-xi
      v-if="tabIng.id === 5"
      @stagetSubjectCallBack="onStagetSubjectCallBack"
      :stageSubject="userStageSubject"
    ></index-fu-xi>
    <div class="history-section">
      <div class="history-header">
        <img src="../../assets/images/list_video.png" class="icon-video" />
        <span class="h-title">看课历史</span>
      </div>
      <div class="history-list ">
        <div v-if="historyCount > 0" class="flex-row-start">
          <div
            class="h-item"
            v-for="(item, index) in userCourseHistoryList"
            :key="index"
          >
          <a :href="`/#/video/${item.video_id}`" target="_blank" class="inline-block">
            <div class="flex-between">
              <el-image
                :src="item.image_url"
                class="h-course-image"
                lazy
              ></el-image>
              <img
                src="../../assets/images/list_line.png"
                class="h-list-line"
                v-if="historyCount != index + 1"
              />
            </div>
            <div class="h-course-name">{{item.title}}</div>
          </a>
          </div>
        </div>
        <div class="h-list-container column" v-else>
          <div class="null">快点来看课吧！</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import "../../assets/css/page.css";
import IndexTongBu from "../template/IndexTongBu.vue";
import IndexZhiShiDian from "../template/IndexZhiShiDian.vue";
import IndexZhuanTi from "../template/IndexZhuanTi.vue";
import IndexFuXi from "../template/IndexFuXi.vue";
import { mapState, mapActions } from "vuex";
export default {
  components: { IndexZhiShiDian, IndexTongBu, IndexZhuanTi, IndexFuXi },
  data() {
    return {
      tabList: [
        { id: 1, name: "知识点微课", banner: "" },
        { id: 2, name: "同步精讲", banner: "" },
        { id: 4, name: "专题课", banner: "" },
        { id: 5, name: "复习课", banner: "" },
      ],
      tabIng: { id: 1, name: "知识点微课", banner: "" },
      userStageSubject: {},
      userCourseHistoryList: [],
      historyCount: 0,
    };
  },
  created() {
    if (Object.keys(this.courseStageSubject).length === 0) {
      this.getUserStageSubject();
    } else {
      this.userStageSubject = this.courseStageSubject;
      this.tabIng = this.tabList[1];
    }
    this.getUserCourseHistory();
  },
  computed: {
    ...mapState(["courseStageSubject"]),
  },
  methods: {
    ...mapActions(["COURSE_STAGE_SUBJECT_IN"]),
    getUserStageSubject() {
      this.getRequest("/wenjiaoopne/kc/user/getUserStageSubject")
        .then((result) => {
          if (Object.keys(result.data).length > 0) {
            this.COURSE_STAGE_SUBJECT_IN(result.data);
            this.userStageSubject = result.data;
          }

          this.tabIng = this.tabList[1];
        })
        .catch(() => {});
    },
    getUserCourseHistory() {
      this.getRequest("/wenjiaoopne/kc/user/getUserCourseHistoryLimit", {
        limit: 5,
      }).then((result) => {
        this.userCourseHistoryList = result.data.list;
        this.historyCount = this.userCourseHistoryList.length;
      });
    },
    onSelectTab(item) {
      // this.onLoading();
      this.tabIng = item;
    },
    onSelectCourse(vid) {
      this.$router.push({ path: `/video/${vid}` });
    },
    onLoading() {
      this.loading = this.$loading({
        lock: true,
        text: "Loading",
      });
    },
    onStagetSubjectCallBack(v) {
      this.COURSE_STAGE_SUBJECT_IN(v);
    },
  },
};
</script>
<style scoped>
.index-container {
  position: relative;
  background: #f1f1f1;
  font: 12px "微软雅黑";
}
.index-container .banner {
  position: relative;
  width: 100%;
  height: 301px;
  background-image: url("../../assets/images/banner/bg_7.png");
  background-size: 100% 100%;
  background-position: center center;
  background-repeat: no-repeat;
}
.index-container .banner-list-box {
  position: relative;
  width: 1195px;
  margin: 0 auto;
  height: inherit;
  background-image: url("../../assets/images/banner/banner_7.png");
  background-size: 100% 100%;
  background-position: center center;
  background-repeat: no-repeat;
}
.index-container .banner-list-box .banner-list {
  width: 100%;
  position: absolute;
  bottom: 0px;
  left: 0;
}
.index-container .banner-list-box .banner-list .banner-list-item:hover {
  background: rgba(74, 184, 235, 0.8) !important;
}
.index-container .banner-list-box .banner-list .banner-list-item {
  position: relative;
  width: 292px;
  height: 55px;
  line-height: 55px;
  text-align: center;
  background: rgba(233, 160, 84, 0.8);
  margin-bottom: 8px;
  font-size: 20px;
  color: #fff;
}
.index-container .banner-list-box .banner-list .active {
  background: rgba(74, 184, 235, 0.8) !important;
}
.index-container .active-icon {
  position: absolute;
  bottom: -8px;
  left: 132px;
  width: 0;
  height: 0;
  border-left: 14px solid transparent;
  border-right: 14px solid transparent;
  border-bottom: 16px solid #ffffff;
}
.history-section {
  width: 100%;
  height: 270px;
  background: #2f2f2f;
}
.history-section .history-header {
  width: 1195px;
  margin: 0 auto;
  padding: 20px 0;
  color: #fff;
}
.history-section .history-list {
  width: 1195px;
  margin: 0 auto;
}

.history-section .history-header .icon-video {
  vertical-align: text-bottom;
}
.history-section .history-header .h-title {
  vertical-align: bottom;
  font-size: 20px;
  margin-left: 8px;
}

.history-section .history-list {
  margin-top: 20px;
}
.history-section .h-item {
  width: 270px;
  color: #b7b8b2;
  cursor: pointer;
}
.history-section .h-item:hover .h-course-name{
  color: rgb(255, 138, 0)!important;
}
.history-section .h-item .h-course-image {
  width: 180px;
  height: 115px;
  border-radius: 5px;
}

.history-section .h-item .h-list-line {
  margin: 0 12px;
}
.history-section .h-course-name {
  width: 180px;
  height: 35px;
  line-height: 35px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 14px;
  color: #b7b8b2;
}
.history-section .h-list-container {
  width: 100%;
}

</style>
